import { useEffect } from "react";
import useLocalStorage from "./useLocalStorage";

/**
 * Custom hook to manage and synchronize state with local storage.
 *
 * @param {string} key - The key to store the value in local storage.
 * @param {any} initialValue - The initial value to set for the key in local storage.
 * @return {Array} An array containing the current value and a function to update the value.
 */
function useSettingsState(key, initialValue) {
  const [value, setValue] = useLocalStorage(key, initialValue);

  useEffect(() => {
    // Set data attribute on body element
    document.body.dataset[key] = value;

    // Replace style sheet if dark theme gets toggled
    if (key === "theme") {
      const theme = value === "dark" ? "dark" : "light";
      const stylesheet = document.querySelector(".js-stylesheet");
      stylesheet.setAttribute("href", `/css/${theme}.css`);
    }
  }, [value, key]);

  return [value, setValue];
}

export default useSettingsState;
